import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      /* Row spacing is carried by each row's own padding; zeroing the
         shared gap keeps the padding tracks exact too. */
      --block-row-gap: 0px;
      display: block;
      color: var(--block-text-color, #222);
    }

    /*
      Mobile: the image bleeds the full width of the grid on row 1, with the
      text, description, and CTA stack inset on row 2. Vertical spacing is set
      with explicit rows and padding, so the grid's mobile row gap is dropped.
    */
    .clive-layout {
      grid-template-rows:
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      /* The grid is inline-grid, so it needs a width to fill the wrapper —
         otherwise a Clive with no image shrinks to its text. */
      width: 100%;
      max-width: 100%;
    }

    .image-column {
      grid-column: 1 / 9;
      grid-row: 1;
    }

    .image-holder {
      width: 100%;
      overflow: hidden;
      display: flex;
      min-height: calc(250rem / var(--default-rem-px-count));
    }

    .image-holder img {
      width: 100%;
      height: auto;
      display: block;
    }

    .text-column {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      gap: calc(40rem / var(--default-rem-px-count));
      padding-top: calc(50rem / var(--default-rem-px-count));
    }

    .text-block {
      display: flex;
      flex-direction: column;
      gap: calc(30rem / var(--default-rem-px-count));
      max-width: 100%;
    }

    /* .header (h1) and .description (p) use the shared type defaults. */

    .cta-stack {
      display: flex;
      flex-direction: column;
      gap: calc(20rem / var(--default-rem-px-count));
      width: calc(221rem / var(--default-rem-px-count));
      max-width: 100%;
    }

    @media (min-width: 600px) {
      /*
        Tablet: image still full bleed on top, then a row holding the text
        block on the left and the CTA stack on the right.
      */
      .clive-layout {
        grid-template-rows:
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .image-column {
        grid-column: 1 / 15;
      }

      .image-holder {
        min-height: calc(409rem / var(--default-rem-px-count));
      }

      .text-column {
        grid-column: 2 / 14;
        display: grid;
        grid-template-columns: 1fr auto;
        gap: var(--between-column-padding);
        align-items: start;
        padding-top: calc(60rem / var(--default-rem-px-count));
      }

      .text-block {
        max-width: calc(356rem / var(--default-rem-px-count));
        gap: calc(60rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      /*
        Desktop: text takes four columns on the left, the image the remaining
        eight and runs through the outer padding column to the right edge of
        the window. The space between them is the grid gutter.
      */
      .clive-layout {
        grid-template-rows:
          minmax(0, auto)
          [last-line];
        height: calc(100vh - calc(122rem / var(--default-rem-px-count)));
        min-height: calc(646rem / var(--default-rem-px-count));
        max-height: calc(950rem / var(--default-rem-px-count));
      }

      /*
        The text sits against the bottom of the image. The top padding is only
        consumed once the text is tall enough to drive the row height itself.
      */
      .text-column {
        grid-column: 2 / 6;
        grid-row: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        gap: calc(100rem / var(--default-rem-px-count));
        padding-top: var(--top-padding-height);
        padding-bottom: calc(40rem / var(--default-rem-px-count));
        align-self: stretch;
      }

      .image-column {
        grid-column: 6 / 15;
        grid-row: 1;
        align-self: stretch;
        display: flex;
      }

      .image-holder {
        min-height: 0;
        width: 100%;
        align-self: stretch;
        max-height: calc(950rem / var(--default-rem-px-count));
        overflow: hidden;
      }

      .image-holder img {
        display: block;
        width: 100%;
        object-fit: cover;
        object-position: left top;
        max-height: calc(950rem / var(--default-rem-px-count));
        height: calc(950rem / var(--default-rem-px-count));
      }

      /* The four-column track is already the design's 435px text measure. */
      .text-block {
        max-width: 100%;
        gap: calc(40rem / var(--default-rem-px-count));
      }
    }
  `,
];
